export default __webpack_public_path__ + "images/models/963288e83f86ce7a4fd038353b24c548.glb";